// Fortify resolution — pure state transition for a single fortify move.
//
// Caller is responsible for:
//   - verifying state.phase === 'fortify' and the per-turn cap (canFortify)
//   - verifying ownership/adjacency/armies-left-behind before calling
//   - deciding when (if ever) to call `advancePhase` afterward
//
// Pure: never mutates `state`; returns a new object.

import type { GameEvent, GameState, PlayerId, TerritoryId } from './types.js'

export interface FortifyMove {
  fromTerritoryId: TerritoryId
  toTerritoryId: TerritoryId
  armies: number
}

export function applyFortify(state: GameState, move: FortifyMove): GameState {
  const newTerritories = state.map.territories.map((t) => {
    if (t.id === move.fromTerritoryId) return { ...t, armies: t.armies - move.armies }
    if (t.id === move.toTerritoryId) return { ...t, armies: t.armies + move.armies }
    return t
  })

  const player = state.players[state.turnIndex] as PlayerId
  const fortifyEvent: GameEvent = {
    kind: 'fortify',
    player,
    fromTerritoryId: move.fromTerritoryId,
    toTerritoryId: move.toTerritoryId,
    armies: move.armies,
    ts: Date.now(),
  }

  return {
    ...state,
    map: { ...state.map, territories: newTerritories },
    fortifiesThisTurn: state.fortifiesThisTurn + 1,
    events: [...(state.events ?? []), fortifyEvent],
  }
}
